import { DialogConfirmation } from '@reapitform/common-ui'
import { useResendAgreement } from '../../api/documents/actions/resend-agreement'
import React from 'react'

interface IResendLinkProps {
  isOpen?: boolean
  onClose?: () => void
  onFinish?: (agreementIds: string[]) => void
  agreementId?: string[]
}

export const ResendLinkModal: React.FC<IResendLinkProps> = ({ isOpen = false, onClose, onFinish, agreementId }) => {
  const { resendAgreement, isLoading } = useResendAgreement()

  if (!agreementId || !agreementId.length) return

  const handleConfirmation = async () => {
    await resendAgreement({ iDs: agreementId })
    onFinish?.(agreementId)
    onClose?.()
  }

  return (
    <DialogConfirmation
      message="The agreement link will be resent via SMS and email to those who haven't signed yet."
      title="Resend Link"
      isLoading={isLoading}
      isOpen={isOpen}
      onCancel={() => onClose?.()}
      onClose={() => onClose?.()}
      onConfirm={handleConfirmation}
      confirmButtonText="Resend"
    />
  )
}
